import React from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useMediaQuery, useTheme } from '@mui/material';

import { AppDispatch, RootState } from '../store';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export function useIsClientInMobileMode() {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));

  return isSmall; // TODO: use brain
}

export function withInMobileMode<TProps>(Component: React.ComponentType<TProps & { inMobileMode: boolean }>) {
  return function WrappedComponent(props: TProps) {
    return <Component inMobileMode={useIsClientInMobileMode()} {...props} />;
  };
}
